import { set } from "lodash";

interface SimulatorRequest {
  onEndSimulated: "resolve" | "reject";
  onErrorData?: any;
  onSuccessData?: any;
}
const simulatorRequest = async (arg: SimulatorRequest) => {
  return new Promise((resolve, reject) => {
    if (arg.onEndSimulated === "resolve") {
      setTimeout(() => {
        resolve(arg.onSuccessData || {});
      }, 3000);
    } else {
      setTimeout(() => {
        reject(arg.onErrorData || {});
      }, 3000);
    }
  });
};

export default simulatorRequest;
